// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".indexBlock-user.indexBlock-user-pc[data-v-12e33f58] {\n  margin-top: 30px;\n}\n.indexBlock-clearC .clearC-pic[data-v-12e33f58] {\n  box-shadow: 0 0 30px 15px rgba(9, 31, 67, 0.3);\n  position: relative;\n}", ""]);
// Exports
module.exports = exports;
